import PropTypes from 'prop-types';
import ReportStepLayout from '../components/ReportStepLayout';
import Footer from '../components/Footer';
import ReportAlertContainer from '../components/ReportAlert';

export default function ReportStepWrapper({location, match, children}) {
    return (
        <ReportStepLayout location={location} match={match}>
            <ReportAlertContainer/>
            {children}
            <Footer location={location} match={match}/>
        </ReportStepLayout>
    );
}
ReportStepWrapper.propTypes = {
    className: PropTypes.string,
    location: PropTypes.object,
    match: PropTypes.object,
};